import { css } from '@emotion/react';

import { SasIcon } from '../SasIcon';
import { theme } from '../theme';

const styles = {
  container: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,
  button: (disabled: boolean) => css`
    padding: ${theme.spacing.sm};
    border-radius: ${theme.borders.radius.lg};
    min-width: fit-content;
    min-height: fit-content;
    cursor: ${disabled ? 'default' : 'pointer'};
    background-color: ${disabled ? theme.colors.gray[1] : theme.colors.blue[2]};
  `,
  buttonContainer: css`
    display: flex;
    flex-direction: row;
    gap: ${theme.spacing.sm};
    align-items: center;
  `,
  label: css`
    font-size: ${theme.fontSize.md};
    border: 1px solid ${theme.colors.gray[1]};
    border-radius: ${theme.borders.radius.md};
    padding: ${theme.spacing.sm};
    padding-left: ${theme.spacing.md};
    padding-right: ${theme.spacing.md}};
  `,
  capitalize: css`
  &::first-letter {
    text-transform: capitalize;
  `,
  textContainer: css`
    width: 100%;
  `,
};

type SpinButtonProps = {
  label: string;
  value: number;
  onChange: (newValue: number) => void;
  disabledIncrease: boolean;
  disabledDecrease: boolean;
};

export const PassengerSpinner = ({ label, value, onChange, disabledIncrease, disabledDecrease }: SpinButtonProps) => {
  return (
    <div css={styles.container}>
      <div css={styles.textContainer}>
        <p css={styles.capitalize}>{label}</p>
      </div>

      <div css={styles.buttonContainer}>
        <button css={styles.button(disabledDecrease)} onClick={() => !disabledDecrease && onChange(value - 1)}>
          <SasIcon name="cl--minus" color={theme.colors.white} />
        </button>

        <span css={styles.label}>{value}</span>

        <button css={styles.button(disabledIncrease)} onClick={() => !disabledIncrease && onChange(value + 1)}>
          <SasIcon name="cl--plus" color={theme.colors.white} />
        </button>
      </div>
    </div>
  );
};
